var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20.125,
    viewBox: "0 0 17 20.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3755",
    "data-name": "Path 3755",
    d: "M1121.52,396.4v1.533a4.166,4.166,0,0,1,2.98,3.959v4.937a4.222,4.222,0,0,1-4.27,4.175h-8.46a4.222,4.222,0,0,1-4.27-4.175v-4.937a4.178,4.178,0,0,1,2.98-3.959V396.4a5.521,5.521,0,1,1,11.042,0Zm-5.51-3.657a3.7,3.7,0,0,1,3.73,3.657v1.318h-7.48V396.38a3.7,3.7,0,0,1,3.75-3.641Zm.88,12.716a.89.89,0,0,1-1.78,0v-2.206a.89.89,0,0,1,1.78,0Z",
    transform: "translate(-1107.5 -390.879)",
    fill: "#192032",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock-.7a6f6cd900353fbedf6463c9aa88dfc1.svg";
export { ForwardRef as ReactComponent };